module.exports = __webpack_public_path__ + "img/ico_avion.0b4253bb.svg";